import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var CVCIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M22 4H2a.5.5 0 0 0-.5.5V6h21V4.5A.5.5 0 0 0 22 4ZM1.5 19.5V9h21v10.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5Zm.5-17a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-15a2 2 0 0 0-2-2H2Zm14.75 13h2a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2Zm-2.5 1a2.5 2.5 0 0 1 2.5-2.5h2a2.5 2.5 0 0 1 0 5h-2a2.5 2.5 0 0 1-2.5-2.5Z",
            clipRule: "evenodd"
        })
    }));
};
